import {
  Autocomplete,
  CircularProgress,
  TextField,
  TextFieldProps,
} from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import { IntervalType } from "services/KnowfullyAdminClient";

type SelectIntervalTypeProps = {
  value?: number;
  onChange: (id: number | undefined) => void;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  textFieldProps?: Partial<TextFieldProps>;
};

const SelectIntervalType = ({
  value,
  onChange,
  label,
  disabled,
  required,
  error,
  textFieldProps,
}: SelectIntervalTypeProps) => {
  const { formatMessage: t } = useIntl();
  const { notificationsConfigurationsService } = useGlobalContext();

  const { data, isLoading } = useQuery(
    ["notificationsConfigurationsService.getIntervalTypes"],
    () => notificationsConfigurationsService.getIntervalTypes(),
  );

  const options = (data?.data ?? []) as IntervalType[];
  const selectedOption = options.find((o) => o.id === value) ?? null;

  return (
    <Autocomplete<IntervalType>
      value={selectedOption}
      onChange={(_event, newValue) => onChange(newValue?.id)}
      options={options}
      loading={isLoading}
      disabled={disabled || isLoading}
      getOptionLabel={(option) => option.name || ""}
      isOptionEqualToValue={(option, val) => option.id === val.id}
      renderInput={(params) => (
        <TextField
          {...params}
          {...textFieldProps}
          variant="standard"
          label={label || t({ id: "intervalType" })}
          required={required}
          error={error}
          InputProps={{
            ...params.InputProps,
            startAdornment: isLoading && <CircularProgress size={16} />,
          }}
        />
      )}
    />
  );
};

export default SelectIntervalType;
